<p-toast></p-toast>
<div class="flex flex-col h-screen">
  <app-header></app-header>
  @if (loading.isLoading()) {
    <div class="fixed top-0 left-0 right-0 z-[10000]">
      <p-progressBar mode="indeterminate" [style]="{ height: '3px' }"></p-progressBar>
    </div>
  }
  <div class="flex-grow overflow-auto pb-14 md:pb-0 flex flex-col min-h-0">
    <div class="flex-grow min-h-0 overflow-auto">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
  <app-bottom-nav></app-bottom-nav>
</div>
<app-cookie-consent></app-cookie-consent>
<app-gdpr-consent-dialog></app-gdpr-consent-dialog>
